import { Stack, Typography } from "@mui/material";
import type { MonthlyFinancialsBlockContent } from "../../../../api/inputFormTypes";
import BlockSection from "../BlockSection";
import MonthlyFinancialsInputForm from "./MonthlyFinancialsInputForm";

interface Props {
  blockId: string;
  content: MonthlyFinancialsBlockContent;
}

const MonthlyFinancialsFormBlock = ({ blockId, content }: Props) => {
  return (
    <Stack spacing={2.5} sx={{ flex: 1 }}>
      {content.tables.map((tableBlock, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <BlockSection key={index}>
          <Typography variant="h6">{tableBlock.name}</Typography>
          <MonthlyFinancialsInputForm
            blockId={blockId}
            columnDefinitions={tableBlock.columns}
            rowDefinitions={tableBlock.rows}
          />
        </BlockSection>
      ))}
    </Stack>
  );
};

export default MonthlyFinancialsFormBlock;
